import { useState } from "react";
import { Play } from "lucide-react";

// Brand film — click-to-play YouTube facade (no iframe until the user asks).
const BRAND_FILM_ID = "2XL4RdlL3E0";

export const BrandFilm = () => {
    const [playing, setPlaying] = useState(false);
    return (
        <div className="relative w-full h-full bg-[#0B1120]" data-testid="home-brand-film">
            {playing ? (
                <iframe
                    data-testid="brand-film-iframe"
                    className="absolute inset-0 w-full h-full"
                    src={`https://www.youtube-nocookie.com/embed/${BRAND_FILM_ID}?autoplay=1&rel=0&modestbranding=1&color=white&playsinline=1`}
                    title="Toothrocket Dental Labs Brand Film — Why Us?"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                />
            ) : (
                <button
                    type="button"
                    onClick={() => setPlaying(true)}
                    data-testid="brand-film-play"
                    aria-label="Play the Toothrocket brand film"
                    className="group absolute inset-0 w-full h-full text-left cursor-pointer"
                >
                    <img
                        src={`https://i.ytimg.com/vi/${BRAND_FILM_ID}/maxresdefault.jpg`}
                        onError={(e) => { e.currentTarget.src = `https://i.ytimg.com/vi/${BRAND_FILM_ID}/hqdefault.jpg`; }}
                        alt="Toothrocket brand film — why us"
                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.03]"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0B1120]/85 via-transparent to-[#0B1120]/35" />
                    <div className="absolute top-4 left-4 px-2.5 py-1 rounded-md bg-black/55 backdrop-blur text-[10px] font-mono-tr tracking-[0.2em] uppercase text-cyan-200 flex items-center gap-2">
                        <span className="h-1.5 w-1.5 rounded-full bg-red-500 animate-pulse" /> Premiere · Toothrocket brand film
                    </div>
                    <div className="absolute inset-0 grid place-items-center">
                        <span className="h-20 w-20 rounded-full bg-white/95 grid place-items-center shadow-[0_20px_60px_-15px_rgba(8,47,73,0.65)] transition-transform duration-300 group-hover:scale-110">
                            <Play size={30} className="text-slate-900 ml-1" fill="currentColor" />
                        </span>
                    </div>
                    <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between gap-3">
                        <div>
                            <div className="font-display text-white text-xl tracking-tight">Why Toothrocket?</div>
                            <div className="text-[11px] text-white/70 font-mono-tr tracking-[0.16em] uppercase mt-1">Watch the film · 1:03</div>
                        </div>
                        <div className="px-3 py-1.5 rounded-full bg-white/95 text-[11px] font-mono-tr tracking-[0.18em] uppercase text-slate-900 items-center gap-2 hidden sm:flex">
                            <span className="h-1.5 w-1.5 rounded-full bg-cyan-500" /> Plays right here
                        </div>
                    </div>
                </button>
            )}
        </div>
    );
};
